import { useKV } from '@/hooks/useLocalStorage';
import { Card, CardContent } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Progress } from '@/components/ui/progress';
import { CheckCircle, GraduationCap, Trophy } from '@phosphor-icons/react';

interface TutorialProgressProps {
  totalTutorials: number;
}

export function TutorialProgress({
  totalTutorials,
}: Readonly<TutorialProgressProps>) {
  const [completedTutorials] = useKV<string[]>('completed-tutorials', []);

  const completedCount = completedTutorials.length;
  const progress = (completedCount / totalTutorials) * 100;

  if (completedCount === 0) {
    return null;
  }

  return (
    <Card className='border-green-200 bg-green-50/30'>
      <CardContent className='p-3'>
        <div className='flex items-center gap-3'>
          <div className='p-1.5 rounded-full bg-green-100'>
            {completedCount === totalTutorials ? (
              <Trophy className='w-4 h-4 text-green-600' />
            ) : (
              <GraduationCap className='w-4 h-4 text-green-600' />
            )}
          </div>
          <div className='flex-1 min-w-0'>
            <div className='flex items-center justify-between mb-1'>
              <span className='text-sm font-medium text-green-800'>
                Learning Progress
              </span>
              <Badge variant='secondary' className='text-xs'>
                {completedCount}/{totalTutorials}
              </Badge>
            </div>
            <Progress value={progress} className='h-2' />
          </div>
          {completedCount === totalTutorials && (
            <CheckCircle className='w-5 h-5 text-green-600' />
          )}
        </div>
        {completedCount === totalTutorials && (
          <div className='mt-2 text-xs text-green-700'>
            🎉 Congratulations! You've mastered the basics of data science!
          </div>
        )}
      </CardContent>
    </Card>
  );
}
